import React from 'react';

export const PageContext = React.createContext(null);
export const DialogContext = React.createContext(null);
export const SelectorContext = React.createContext(null);
export const DaypickerContext = React.createContext(null);